import inspectionHero from "@/assets/services/inspection-readiness/hero.jpg.asset.json";
import qmsHero from "@/assets/services/qms/hero.jpg";
import capaHero from "@/assets/services/capa/hero.jpg";
import { GXP_TRAINING_CARD } from "./gxpQaTraining";
import { INVESTIGATIONS_CAPA_CARD } from "./investigationsCapa";
import { getServiceBySlug } from "./servicesData";

const QA_PATH = "/en/services/quality-assurance";
const HERO_BASE = "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/service-images/quality-assurance%2Fheroes";
export const QA_ALL_INDUSTRIES = ["Pharma & BioTech", "Medical Devices", "In Vitro Diagnostics"];

export const QA_OVERVIEW_CARDS = [
  {
    title: "Regulatory Inspection Readiness",
    href: `${QA_PATH}/regulatory-inspection-readiness`,
    image_url: inspectionHero.url,
    description: "Before, during and after regulatory inspections by the FDA and EU/EEA authorities: mock inspections, compliance assessments, back-room support, inspection responses and remediation, towards a state of permanent inspection readiness.",
    industries: QA_ALL_INDUSTRIES,
  },
  {
    title: "QA Support & Outsourcing",
    href: `${QA_PATH}/qa-support-outsourcing`,
    image_url: `${HERO_BASE}%2Foutsourced-qa-hero.jpg`,
    description: "QA expertise or a managed QA support model for document and validation review, batch record review, deviations, change control, supplier quality and interim QA leadership.",
    industries: QA_ALL_INDUSTRIES,
  },
  {
    title: "Integrated Audit Solutions",
    href: `${QA_PATH}/integrated-audit-solutions`,
    image_url: `${HERO_BASE}%2Fgxp-audits-hero.jpg`,
    description: "Internal and supplier audits across GMP, GDP, GCP, GVP and medical device/IVD requirements, covering the full audit lifecycle from planning and execution to reporting, follow-up and audit program management.",
    industries: QA_ALL_INDUSTRIES,
  },
  { ...GXP_TRAINING_CARD, industries: QA_ALL_INDUSTRIES },
  {
    title: "QMS Development & Optimization",
    href: `${QA_PATH}/qms-development-optimization`,
    image_url: qmsHero,
    description: "Implementation and improvement of your QMS/PQS: policies and procedures, QMS software selection and roll-out, personnel training, and maturity assessments to modernize fragmented or outdated systems.",
    industries: QA_ALL_INDUSTRIES,
  },
  {
    title: "QP, RP & PRRC Services",
    href: `${QA_PATH}/qp-rp-prrc-services`,
    image_url: `${HERO_BASE}%2Fqp-rp-hero.jpg`,
    description: "Qualified professionals for Qualified Person (GMP) and Responsible Person (GDP) functions, matched to the role and jurisdiction and subject to applicable authorization requirements.",
    industries: ["Pharma & BioTech"],
  },
  {
    title: "QA Consultancy (APR & PQR)",
    href: `${QA_PATH}/qa-consultancy-apr-pqr`,
    image_url: `${HERO_BASE}%2Fapr-pqr-hero.jpg`,
    description: "Establish, improve or execute your Annual Product Review and Product Quality Review processes: data collection, trend analysis, report drafting, quality review and identification of follow-up actions.",
    industries: ["Pharma & BioTech"],
  },
  { ...INVESTIGATIONS_CAPA_CARD, image_url: capaHero, industries: QA_ALL_INDUSTRIES },
  {
    title: "Regulatory Toxicology",
    href: "/en/services/regulatory-toxicology",
    image_url: getServiceBySlug("toxicology")?.heroImage ?? getServiceBySlug("regulatory-toxicology")?.heroImage,
    description: "EUROTOX-certified toxicological risk assessments for your products, processes and equipment, from elemental impurities to extractables and leachables, aligned with ICH Q3D, ICH M7 and other relevant guidelines.",
    industries: ["Pharma & BioTech"],
    imageLabel: "Toxicology service",
    imageLabelClassName: "bg-qa-copy-toxicology text-qa-copy-ink",
  },
];

export const matchesOfferingIndustry = (industries: string[] | undefined, active: string) =>
  active === "All" || !industries || industries.includes(active);